/* JsonPatchModel.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const jsonPatch = require("fast-json-patch");

class JsonPatchModel extends EventEmitter{
    constructor(){
        super();
    }
    /*******************************************/
    /* START DIRTY HANDLING METHODS */
    /*******************************************/
    isDirty(){
        if(this._pendingPatches){
            return true;
        }
        else{
            return false;
        }
    }
    isClean(){
        return !this.isDirty();
    }
    /*******************************************/
    /* END DIRTY HANDLING METHODS */
    /* START PENDING PATCHES */
    /*******************************************/
    clearPendingPatches(silent){
        return this._setPendingPatches([],silent);
    }
    updatePendingPatches(pp,silent){
        if(_.isArray(pp)){
            let oldPristineValue = this.getPristineValue();

            //combine the patches
            let combinedPatches = this._pendingPatches || [];
            combinedPatches = combinedPatches.concat(pp);

            let newPristineValue = this.getPristineValue();
            //apply the combined patches
            jsonPatch.applyPatch(newPristineValue,combinedPatches);

            //figure out the latest pending patches
            let newPatches = jsonPatch.compare(oldPristineValue,newPristineValue);
            this._setPendingPatches(newPatches,silent);
        }
        return this;
    }
    _setPendingPatches(pp,silent){
        let oldPatches = this._pendingPatches;
        if(_.isArray(pp)){
            if(_.isEmpty(pp)){
                this._pendingPatches = null;
                if(!silent) {
                    this.emit("PendingPatchesCleared", oldPatches);
                }
                //If there we previously patches are dirtyState has changed
                if(oldPatches){
                    if(!silent) {
                        this.emit("DirtyStateChanged",false,true,oldPatches);
                    }
                }
            }
            else{
                this._pendingPatches = pp;
                //If there we previously NO patches are dirtyState has changed
                if(oldPatches === null && !silent){
                    this.emit("DirtyStateChanged",true,false,this._pendingPatches);
                }
            }
            if(!silent) {
                this.emit("PendingPatchesChanged",this._pendingPatches,oldPatches);
            }
        }
        else if(pp === undefined || pp === null){
            return this.clearPendingPatches(silent);
        }
        else{
            throw new Error("Pending patches must be a valid JsonPatch Array.");
        }
        return this;
    }
    get pendingPatches(){
        return this.getPendingPatches();
    }
    getPendingPatches(){
        return this._pendingPatches;
    }
    get value(){
        return this.getValue();
    }
    getValue(){
        if(this.isDirty()) {
            let newVal = this.getPristineValue();
            jsonPatch.applyPatch(newVal, this.pendingPatches);
            return newVal;
        }
        else{
            return this.getPristineValue();
        }
    }
    /********************************/
    /* END PENDING PATCHES */
    /* START PRISTINE VALUE */
    /********************************/
    applyPendingPatches(){
        if(this.isDirty()) {
            this._applyPatchToPristineValue(this.pendingPatches);
            this.clearPendingPatches();
        }
    }
    _applyPatchToPristineValue(patches, silent){
        let before = this.getPristineValue();
        jsonPatch.applyPatch(this._pristineValue,patches);
        if(!silent) {
            this.emit("PristineValueChanged", this._pristineValue, before);
        }
        return this;
    }
    _clearPristineValue(silent){
        let before = this._pristineValue;
        this._setPristineValue({},true);
        if(!silent){
            this.emit("PristineValueCleared",before);
        }
        return this;
    }
    _setPristineValue(val,silent){
        let before = this._pristineValue;
        this._pristineValue = val;
        if(!silent) {
            this.emit("PristineValueChanged", this._pristineValue, before);
        }
        return this;
    }
    get pristineValue(){
        return this.getPristineValue();
    }
    getPristineValue(){
        return _.cloneDeep(this._pristineValue || {});
    }
    /********************************/
    /* END PRISTINE VALUE */
    /********************************/
}
module.exports=JsonPatchModel;